const BookingStatuses = {
  BOOKING_STATUS_PENDING: '0',
  BOOKING_STATUS_AGENT_VIEWED: '1',
  BOOKING_STATUS_PROCESSING: '2',
  BOOKING_STATUS_ONGOING: '3',
  BOOKING_STATUS_ARRIVED: '4',
  BOOKING_STATUS_INVOICE_CREATED: '5',
  BOOKING_STATUS_INVOICE_SENT: '6',
  BOOKING_STATUS_FOR_DELIVERY: '7',
  BOOKING_STATUS_DELIVERED: '8',
  BOOKING_STATUS_COMPLETED: '9',
  BOOKING_STATUS_CANCELLED: '10'
};

BookingStatuses.install = function (Vue) {
    Vue.prototype.$getConstBookingStatus = (key) => {
        return BookingStatuses[key];
    }
}

export default BookingStatuses;
